import type { IntlConfig } from "react-intl";

const loadLocaleData = async (locale: string): Promise<IntlConfig["messages"]> => {
  switch (locale) {
    case "es":
      // @ts-ignore
      return import("./compiled/es.json");
    case "fr":
      // @ts-ignore
      return import("./compiled/fr.json");
    case "hi":
      // @ts-ignore
      return import("./compiled/hi.json");
    case "pt":
    case "pt-BR":
      // @ts-ignore
      return import("./compiled/pt.json");
    case "ru":
      // @ts-ignore
      return import("./compiled/ru.json");
    default:
      // @ts-ignore
      return import("./compiled/en.json");
  }
};

export default loadLocaleData;
